import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'

export const getQuickAssessmentCorporateThunk = createAsyncThunk(
  'financialAnalysis/GET_QUICK_ASSESSMENT_CORPORATE',
  async (data, { rejectWithValue }) => {
    const response = await FinancialAnalysisService.getQuickAssessmentCorporate(
      data,
    )
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadQuickAssessmentCorporateThunk = createAsyncThunk(
  'financialAnalysis/DOWNLOAD_QUICK_ASSESSMENT_CORPORATE',
  async (data) => {
    const response =
      await FinancialAnalysisService.downloadQuickAssessmentCorporate(data)
    handleExport(response.data, response.filename)
  },
)
